// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { handleSignOut } from '@/lib/helpers/handle-sign-out';
import { ORIGIN_STRING } from '@/lib/constants';
import { setRedirectCookie } from '@/lib/helpers/utils';
import { ssoLogoutLink } from '@/lib/helpers/sso-links';

// components
import CookieSettings from '@/components/CookieSettings/CookieSettings';
import NavLink  from '@/components/Navigation/NavLink';

// svgs
import GearIcon from '@/public/svg/gear.svg';
import PassportCompass from '@/public/svg/compass-rose.svg';
import PrivacyIcon from '@/public/svg/privacy.svg';
import SignOutIcon from '@/public/svg/sign-out.svg';
import UserIcon from '@/public/svg/user.svg';

// styles
import styles from './UserMenu.module.scss';

interface UserMenuProps {
  className: string;
  isLocalized: boolean;
  isStationPassportEnabled: boolean;
  ketchEnabled?: boolean;
}

const UserMenu = (props: UserMenuProps) => {
  const {
    className,
    isLocalized,
    isStationPassportEnabled,
    ketchEnabled,
  } = props;

  return (
    <div className={`${className} ${styles.user_menu}`} data-sentry-component="UserMenu" data-sentry-source-file="UserMenu.tsx">
      <ul className={styles.user_menu_inner}>
        <li>
          <a
            href={`${ORIGIN_STRING}/sso/profile-link`}
            onClick={() => setRedirectCookie()}
            className={styles.profile_name}
          >
            <UserIcon className={styles.user_icon} data-sentry-element="UserIcon" data-sentry-source-file="UserMenu.tsx" /> Account
          </a>
        </li>

        <li>
          <NavLink href="/settings/site-settings/" data-sentry-element="NavLink" data-sentry-source-file="UserMenu.tsx">
            <GearIcon className={styles.gear_icon} data-sentry-element="GearIcon" data-sentry-source-file="UserMenu.tsx" /> Site Settings
          </NavLink>
        </li>

        {(isLocalized && isStationPassportEnabled) && (
        <li>
          <NavLink href="/settings/membership-settings/">
            <PassportCompass /> Membership & Passport
          </NavLink>
        </li>
        )}

        {ketchEnabled && (
          <li>
            <CookieSettings text="Privacy Settings">
              <PrivacyIcon />
            </CookieSettings>
          </li>
        )}

        <li>
          <a
            href={ssoLogoutLink}
            onClick={handleSignOut}
            className={styles.sign_out}
          >
            <SignOutIcon data-sentry-element="SignOutIcon" data-sentry-source-file="UserMenu.tsx" /> Sign Out
          </a>
        </li>
      </ul>
    </div>
  );
};

export default UserMenu;
